import React from 'react';
import Box, { BoxProps } from '@mui/material/Box';

interface IContentProps extends BoxProps {
  header?: boolean;
}

export function Content(props: IContentProps) {
  const { sx, header = false, children, ...rest } = props;

  const defaultSx = { fontSize: 14, fontWeight: header ? 'bolder' : 'normal', ...sx };

  return (
    <Box sx={defaultSx} {...rest}>
      {children}
    </Box>
  );
}
